

exports.__esModule = true;

var _directive = require('./component/directive.js');

Object.defineProperty(exports, '$xoShippingOptions', {
  enumerable: true,
  get: function get() {
    return _directive.$xoShippingOptions;
  }
});

var _lib = require('./lib');

Object.keys(_lib).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _lib[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-shipping-options/src/index.js
// module id = ../node_modules/xo-shipping-options/src/index.js
// module chunks = 0